<template>
  <div>
    ForgotPassword page
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      // some data
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/singIn/ForgotPassword/ForgotPassword.vue